$(document).ready(function() {
  if ($(window).width() <= 479) {
    $('.credential-img-box img').replaceWith(`<img src="https://imagecdn.rocketbird.cn/official/image/new/about/credential-img-mobile.png" alt="认证、知识产权">`);
  } else {
    $('.introduction-container .introduction-img-box').html(`<img src="https://imagecdn.rocketbird.cn/official/image/new/about/introduction-img.png" alt="勤鸟联合创始人 CEO 陈霄"></img>`)
    

    // pc 断行不一样
    $('.market-container .market-desc').html(
      `<p>中国健身俱乐部精英论坛是由勤鸟<span style="font-size: 0.15rem;">（重庆勤鸟圈科技有限公司）</span></p>
      <p>打造的专属中国体育产业投资人的高端论坛，</p>
      <p>一年一度的中国体育健身休闲产业投资人的嘉年华。</p>
      <p>2018年在渝成功举办首届，</p>
      <p>被业界公认为最具含金量的IP论坛。</p>
      <p>重庆智慧体育名片、两会一展一论坛，</p>
      <p>专属中国体育健身休闲产业投资人的年度嘉年华, </p>
      <p>引领全国健身行业发展，启迪行业智慧！</p>`
    )
  }
  
  $('#joinEmail').one('click', function() {
    $('#mailTips').show();
  });
});
